import { CompanyModel } from 'api/auth/company/models';
import { Exclude, Expose, Type } from 'class-transformer';

@Exclude()
export class FlockRenewalCartRequest {
  @Expose()
  breedFlockCodes?: string[] | null;

  @Expose()
  companyId?: number | null;
}

@Exclude()
export class OrderCartItemModel {
  @Expose()
  description?: string | null;

  @Expose()
  quantity?: number | null;

  @Expose()
  unitCost?: number | null;

  @Expose()
  subTotal?: number | null;

  @Expose()
  tax?: number | null;

  @Expose()
  total?: number | null;

  @Expose()
  productId?: number | null;

  @Expose()
  linkedItemType?: number | null;

  @Expose()
  linkedItemId?: string | null;
}

@Exclude()
export class OrderCartModel {
  @Expose()
  id?: number | null;

  @Expose()
  companyId?: number | null;

  @Expose()
  userId?: string | null;

  @Expose()
  @Type(() => Date)
  dateCreated?: Date | null;

  @Expose()
  @Type(() => OrderCartItemModel)
  items?: OrderCartItemModel[] | null;

  @Expose()
  subTotal?: number | null;

  @Expose()
  tax?: number | null;

  @Expose()
  total?: number | null;
}

@Exclude()
export class OrderCartResponseModel {
  @Expose()
  @Type(() => OrderCartModel)
  cart?: OrderCartModel | null;

  @Expose()
  key?: string | null;
}

@Exclude()
export class FlockSubmissionCartRequest {
  @Expose()
  submissionID?: number | null;

  @Expose()
  companyId?: number | null;
}

@Exclude()
export class OrderCompletedResponseModel {
  @Expose()
  success?: boolean | null;

  @Expose()
  orderId?: number | null;

  @Expose()
  errorMessage?: string | null;
}

@Exclude()
export class FreePaymentRequest {
  @Expose()
  CartId?: number | null;
}

@Exclude()
export class RequestRefundItemModel {
  @Expose()
  orderItemId?: number | null;

  @Expose()
  quantity?: number | null;

  @Expose()
  productId?: number | null;

  @Expose()
  description?: string | null;

  @Expose()
  total?: number | null;
}

@Exclude()
export class RequestRefundPaymentModel {
  @Expose()
  orderPaymentId?: number | null;

  @Expose()
  @Type(() => Date)
  paymentDate?: Date | null;

  @Expose()
  statusId?: number | null;

  @Expose()
  statusName?: string | null;

  @Expose()
  amount?: number | null;

  @Expose()
  providerId?: number | null;

  @Expose()
  providerName?: string | null;
}

@Exclude()
export class RequestRefundRefundItemModel {
  @Expose()
  orderItemId?: number | null;

  @Expose()
  quantity?: number | null;

  @Expose()
  amount?: number | null;
}

@Exclude()
export class RequestRefundRefundModel {
  @Expose()
  refundId?: number | null;

  @Expose()
  externalId?: string | null;

  @Expose()
  @Type(() => Date)
  dateCreated?: Date | null;

  @Expose()
  createdById?: string | null;

  @Expose()
  statusId?: number | null;

  @Expose()
  statusName?: string | null;

  @Expose()
  refundAmount?: number | null;

  @Expose()
  @Type(() => RequestRefundRefundItemModel)
  items?: RequestRefundRefundItemModel[] | null;
}

@Exclude()
export class CreateRefundRequestItem {
  @Expose({ name: 'OrderItemId' })
  orderItemId?: number | null;

  @Expose({ name: 'Quantity' })
  quantity?: number | null;

  @Expose({ name: 'RefundAmount' })
  refundAmount?: number | null;
}

@Exclude()
export class CreateRefundRequest {
  @Expose({ name: 'OrderId' })
  orderId?: number | null;

  @Expose({ name: 'Items' })
  @Type(() => CreateRefundRequestItem)
  items?: CreateRefundRequestItem[] | null;

  @Expose({ name: 'Reason' })
  reason?: string | null;
}

@Exclude()
export class RequestRefundModel {
  @Expose()
  orderId?: number | null;

  @Expose()
  @Type(() => Date)
  orderDate?: Date | null;

  @Expose()
  orderStatusId?: number | null;

  @Expose()
  orderStatusName?: string | null;

  @Expose()
  orderTotal?: number | null;

  @Expose()
  @Type(() => RequestRefundItemModel)
  orderItems?: RequestRefundItemModel[] | null;

  @Expose()
  @Type(() => RequestRefundPaymentModel)
  orderPayments?: RequestRefundPaymentModel[] | null;

  @Expose()
  @Type(() => RequestRefundRefundModel)
  existingRefunds?: RequestRefundRefundModel[] | null;
}

@Exclude()
export class OrderInvoicePaymentModel {
  @Expose()
  orderPaymentId?: number | null;

  @Expose()
  @Type(() => Date)
  paymentDate?: Date | null;

  @Expose()
  statusId?: number | null;

  @Expose()
  statusName?: string | null;

  @Expose()
  amount?: number | null;

  @Expose()
  providerId?: number | null;

  @Expose()
  providerName?: string | null;
}

@Exclude()
export class OrderItemModel {
  @Expose()
  id?: number | null;

  @Expose()
  productId?: number | null;

  @Expose()
  description?: string | null;

  @Expose()
  quantity?: number | null;

  @Expose()
  unitCost?: number | null;

  @Expose()
  subTotal?: number | null;

  @Expose()
  tax?: number | null;

  @Expose()
  total?: number | null;

  @Expose()
  linkedItemType?: number | null;

  @Expose()
  linkedItemId?: string | null;
}

@Exclude()
export class RefundModel {
  @Expose()
  id?: number | null;

  @Expose()
  orderId?: number | null;

  @Expose()
  statusId?: number | null;

  @Expose()
  refundAmount?: number | null;

  @Expose()
  @Type(() => Date)
  dateCreated?: Date | null;
}

@Exclude()
export class OrderInvoiceModel {
  @Expose()
  orderId?: number | null;

  @Expose()
  orderNumber?: string | null;

  @Expose()
  @Type(() => Date)
  orderDate?: Date | null;

  @Expose()
  statusId?: number | null;

  @Expose()
  statusName?: string | null;

  @Expose()
  subTotal?: number | null;

  @Expose()
  gst?: number | null;

  @Expose()
  total?: number | null;

  @Expose()
  @Type(() => CompanyModel)
  company?: CompanyModel | null;

  @Expose()
  @Type(() => OrderItemModel)
  items?: OrderItemModel[] | null;

  @Expose()
  @Type(() => OrderInvoicePaymentModel)
  payments?: OrderInvoicePaymentModel[] | null;

  @Expose()
  @Type(() => RefundModel)
  refunds?: RefundModel[] | null;
}
